import React from "react";
import Modal from "../../../shared/ui/Modal";

interface SortOrderEditModalProps {
    show: boolean;
    title: string;
    currentSortOrder: number | null;
    onHide: () => void;
    onSubmit: (sortOrder: number) => Promise<void>;
}

export const SortOrderEditModal: React.FC<SortOrderEditModalProps> = ({
    show,
    title,
    currentSortOrder,
    onHide,
    onSubmit,
}) => {
    const [sortOrderValue, setSortOrderValue] = React.useState<string>("0");
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>("");

    React.useEffect(() => {
        if (!show) {
            return;
        }
        setSortOrderValue(String(currentSortOrder ?? 0));
        setIsSubmitting(false);
        setErrorMessage("");
    }, [show, currentSortOrder]);

    const handleSubmit = async () => {
        if (isSubmitting) {
            return;
        }

        const parsed = Number(sortOrderValue);
        if (!Number.isInteger(parsed)) {
            setErrorMessage("우선순위는 정수로 입력해 주세요.");
            return;
        }

        setIsSubmitting(true);
        setErrorMessage("");

        try {
            await onSubmit(parsed);
        } catch (error: any) {
            setErrorMessage(error?.message || "우선순위 저장 중 오류가 발생했습니다.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            size="lg"
            scrollable={true}
        >
            <Modal.Header closeButton>
                <Modal.Title className="fs-5">{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                        {errorMessage}
                    </div>
                )}

                <div className="mb-3">
                    <label htmlFor="id_sort_order_modal" className="form-label">우선순위</label>
                    <input
                        id="id_sort_order_modal"
                        type="number"
                        className="form-control"
                        value={sortOrderValue}
                        onChange={(e) => setSortOrderValue(e.target.value)}
                        disabled={isSubmitting}
                    />
                    <div className="form-text">우선순위가 높을수록 위에 배치, 같은 순위 시 생성일시 순</div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button type="button" className="btn btn-secondary" onClick={onHide} disabled={isSubmitting}>
                    취소
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? "저장중..." : "저장"}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default SortOrderEditModal;
